// useViewport — single source for "are we on a phone-width viewport".
// The UI is inline-style driven (no Tailwind classes on elements), so responsive
// behavior is branched in JS off this hook rather than CSS breakpoints.
import { useEffect, useState } from "react";

// 768px = tablet/phone boundary (md). Below this we switch to the mobile layout
// (drawer nav, single-column forms, horizontally-scrollable tables).
export const MOBILE_MAX = 768;

const query = `(max-width: ${MOBILE_MAX}px)`;

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const on = () => setMobile(mql.matches);
    on();
    mql.addEventListener("change", on);
    return () => mql.removeEventListener("change", on);
  }, []);
  return mobile;
}

// Collapse a fixed multi-column grid template to a single column on mobile.
// `cols(mobile, "1.8fr 1fr 1fr 1fr")` → "1fr" on phones, the desktop template otherwise.
export const cols = (mobile: boolean, desktop: string, mobileTemplate = "1fr"): string =>
  mobile ? mobileTemplate : desktop;
